import { render, staticRenderFns } from "./adminAccountManage.vue?vue&type=template&id=45551ec0&scoped=true"
import script from "./adminAccountManage.vue?vue&type=script&lang=js"
export * from "./adminAccountManage.vue?vue&type=script&lang=js"
import style0 from "./adminAccountManage.vue?vue&type=style&index=0&id=45551ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45551ec0",
  null
  
)

export default component.exports